import { createAsyncThunk } from '@reduxjs/toolkit';

import { auth } from 'src/app/database';
import api from 'src/app/apiSingleton';

import { setIssuerBrokersMeta } from './browseBrokers.slice';

export const getIssuerBrokers = createAsyncThunk(
  'browse-brokers/get-issuer-brokers',
  async (data, thunkApi) => {
    try {
      const token = await auth.currentUser.getIdToken();

      api.apiClient.setToken(token);

      let payload = { ...data };

      for (const item in payload) {
        if (!payload[item]) {
          delete payload[item];
        }
      }

      const response = await api.browseBrokers.getIssuerBrokers(payload);

      thunkApi.dispatch(setIssuerBrokersMeta(response?.meta));

      return response.items?.map((item) => ({ ...item, sic_code: item?.account_sic_code }));
    } catch (err) {
      console.warn(err);
    }
  },
);
